// 操作日志
import {getChannelByType} from "@/servers/prod/log"

const operatorLog = {
  state: () => ({
    subCode: [], // 根据日志类型查询对应的途径
   
  }),
 
  mutations: {
    setSubCode(state, data) {
      state.subCode = data
    }

  },
  actions: {
    // 根据日志类型查询对应的途径列表
    async fetch_channelByType({commit}, payload) {
      console.log(payload);
      const res = await getChannelByType(payload);
      commit('setSubCode', res);
    }
    
  },
  getters: {
    getSubCode(state) {
      const codeList = state.subCode;
      return codeList.map(item => {
        return {
          label: item.desc,
          value: item.subCode
        }
      })
    },
    subCodeMap(state) {
      const codeList = state.subCode;
      const mapObj = {};
      codeList.forEach(item => {
        mapObj[item.desc] = item.subCode
      });
      return mapObj
    }
  }
}

export default operatorLog

